import getSymbolFromCurrency from 'currency-symbol-map';
import type { Payment } from 'src/services/billingService';

// "<amount> <currency symbol>", or a dashed placeholder when there is no amount.
export const formatPaymentAmount = (payment?: Payment) => {
  if (!payment?.amount) return '-----';

  const symbol = payment.currency ? getSymbolFromCurrency(payment.currency) : '';
  return `${payment.amount} ${symbol}`;
};
